import React from 'react'
import { Modal, Box } from '@mui/material'
import SavePaymentMethod from './SavePaymentMethod'

interface SavePaymentMethodModalProps {
  isOpen: boolean
  handleClose: () => void
}

const SavePaymentMethodModal: React.FC<SavePaymentMethodModalProps> = ({
  isOpen,
  handleClose,
}) => {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <>
        <Box
          sx={(theme) => ({
            background: 'white',
            zIndex: theme.zIndex.drawer + 1,
            position: 'absolute',
            top: '53%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '5px',
            display: 'flex',
            flexDirection: 'row',
            boxSizing: 'border-box',
          })}
        >
          <SavePaymentMethod />
        </Box>
      </>
    </Modal>
  )
}

export default SavePaymentMethodModal
